import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ROESetup } from "../../components/ROESetup";

export const ROESetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="ROE Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "ROE", navigateTo: "/company/departments/setup" }
      ]}
      mainContents={<ROESetup testId="roe-setup"/>}
    />
  );
};
